module.exports = __webpack_public_path__ + "img/main_bottopm_top2.0c4b8854.png";